
// service imports
import { userData, userHasAccess, userLogado } from "services/LoginFunctions"

// constant imports
import { inputGroupNames } from "constants/inputGroupNames"
import { ROLE } from "constants/userRoles"
import { TIPO, SUBTIPOFROMTIMPOIMOVEL, ehValido, SUBTIPO } from "constants/tiposDoc"
import { tipoImovelIDFromNome } from "constants/tiposImovel"

import * as SERVICOS from "constants/servicosTaxasV2"


// console.log("criarDocBodyBD")
// console.log("nameServ")
// console.log(nameServ)
// console.log("formData")
// console.log(formData)

// console.log("criarDocBodyInterno")
// console.log("nameServ")
// console.log(nameServ)
// console.log("formData")
// console.log(formData)

// console.log("criarDocBodyBDFromGuia")
// console.log("tipoDoc")
// console.log(tipoDoc)
// console.log("subTipoDoc")
// console.log(subTipoDoc)
// console.log("guiaData")
// console.log(guiaData)
// console.log("docData")
// console.log(docData)
// console.log("formdata")
// console.log(formData)


  // guia e multa
  // const fatoGer = docData?.fatoGerador ?? MontarFatoGerador(docData, idServico, taxInputs.fatoGeradorProtocolo, tipoServico, taxInputs.tipoImovel ?? taxInputs?.subTipoDoc)
  // let parcelasTexto = determineParcelasData(idServico, temParcelamento(docData, idServico), formData.parcelasPagamento, taxResults.taxaTotal, taxResults.outorga)
  // if (docData)
  // {
  //     parcelasTexto = parcelasTexto || docData.detalhesGuia.parcelamento
  // }
  // let obsTexto = docData ? "" : determineTaxData(taxResults.detalhesDaAvaliacao, taxResults.detalhesDoCalculo, taxInputs)
  // if (docData)
  // {
  //     let linesObs = docData.detalhesGuia.detalhesTaxa[0].split("\n")
  //     linesObs = linesObs.filter(det => !det.includes("parcela") && !det.includes("parcelada"))
  //     for (let i = 0 ; i <= linesObs.length - 1 ; i += 1)
  //     {
  //         if (i === 0)
  //         {
  //             obsTexto += linesObs[i]
  //             continue
  //         }

  //         obsTexto += "\n" + linesObs[i]
  //     }
  // }
  // criarDocBodyBD("GuiaPag", taxInputs, formData, taxResults, fatoGer, obsTexto + parcelasTexto, idServico)



  // criarDocBodyBD("Multa", taxInputs, formData, taxResults, idServico, "")
export function criarDocBodyBD(nameServ, taxInputData, formData, taxResultsData, fatoGerador, obsTexto, idServicoGeradorGuia)
{

  if (!userLogado) { console.log("Erro: Tentando gerar documento sem estar logado em criarDocBodyBD") ; return }
  if (!userHasAccess(ROLE.ANALISTA)) { console.log("Erro: Tentando gerar documento sem ter permissão de analista em criarDocBodyBD") ; return }
  if (!nameServ) { console.log("Erro: Tentando gerar documento sem passar nome do serviço em criarDocBodyBD") ; return }
  if (!taxInputData) { console.log("Erro: Tentando gerar documento sem dados de input das taxas em criarDocBodyBD") ; return }
  if (!formData) { console.log("Erro: Tentando gerar documento sem passar os dados do documento em criarDocBodyBD") ; return }
  if (!taxResultsData) { console.log("Erro: Tentando gerar documento sem resultados das taxas em criarDocBodyBD") ; return }

  const tipoDoc = MapNameServToTipoDoc(nameServ)
  const idTipoImovel = tipoImovelIDFromNome[taxInputData.tipoImovel]
  const subTipoDoc = nameServ === TIPO.GuiaPag ? null : idTipoImovel

  if (!ehValido(tipoDoc, subTipoDoc)) { console.log("Erro: Tentando gerar documento de tipo inválido em criarDocBodyBD") ; return }

  const fatoConstitutivo = fatoConstitutivoMulta(fatoGerador, taxInputData.areaConstruida, taxInputData.obraEmExecucao, taxInputData.tipoImovel, formData)
  
  const { taxaTotal, complexidade, taxaDemarcacao, taxaVistoria, outorga } = dataFromTaxResults(taxResultsData)


  return {
    ...DadosGerais(tipoDoc, subTipoDoc, formData, undefined, fatoGerador, idServicoGeradorGuia),
    ...SecCertifico(formData), // tipoDoc, formData, formData?.tipoImovel
    ...montagemSecoes(tipoDoc, subTipoDoc, formData, idTipoImovel),
    ...(tipoDoc !== "Multa" ? SecDetalhesGuia(idServicoGeradorGuia, formData, obsTexto, taxInputData, taxResultsData) : {}),
    ...(tipoDoc === "Multa" ? SecDetalhesMulta(formData, fatoConstitutivo, taxInputData) : {}),
    ...SecEspecificEmpreendimento(formData, taxInputData),
    // ...SecNotas(data),
    //...SecObs(tipoDoc, subTipoDoc, data),
    // ...SecRepresentante(data),
    ...SecTaxas(taxaTotal, taxaDemarcacao, taxaVistoria, complexidade, outorga)
  }
}

export function criarDocBodyInterno(nameServ, tipoDoc, subTipoDoc, formData)
{

  if (!userLogado) { console.log("Erro: Tentando gerar documento sem estar logado em criarDocBodyInterno") ; return }
  if (!userHasAccess(ROLE.ANALISTA)) { console.log("Erro: Tentando gerar documento sem ter permissão de analista em criarDocBodyInterno") ; return }
  if (!ehValido(tipoDoc, subTipoDoc)) { console.log("Erro: Tentando gerar documento de tipo inválido em criarDocBodyBD") ; return }
  if (!nameServ) { console.log("Erro: Tentando gerar documento sem passar nome do serviço em criarDocBodyInterno") ; return }
  if (!formData) { console.log("Erro: Tentando gerar documento sem passar os dados do documento em criarDocBodyInterno") ; return }
  
  return {
    ...DadosGerais(tipoDoc, subTipoDoc, formData, undefined, undefined, undefined),
    ...SecCertifico(formData), // tipoDoc, formData, formData?.tipoImovel
    ...montagemSecoes(tipoDoc, subTipoDoc, formData, undefined),
    // ...SecDetalhesGuia(data, obsTexto, taxInputData),
    // ...SecDetalhesMulta(fatoGerador, data, taxInputData),
    // ...SecEspecificEmpreendimento(data, taxInputData),
    // ...SecNotas(nameServ, data),
    ...SecObs(formData),
    // ...SecRepresentante(data),
    // ...SecTaxas(taxaTotal, taxaDemarcacao, taxaVistoria, complexidade)
  }
}

export function criarDocBodyBDFromGuia(tipoDoc, subTipoDoc, guiaData, docData, formData)
{

  if (!userLogado) { console.log("Erro: Tentando gerar documento sem estar logado em criarDocBodyBDFromGuia") ; return }
  if (!userHasAccess(ROLE.ANALISTA)) { console.log("Erro: Tentando gerar documento sem ter permissão de analista em criarDocBodyBDFromGuia") ; return }
  if (!ehValido(tipoDoc, subTipoDoc)) { console.log("Erro: Tentando gerar documento de tipo inválido em criarDocBodyBD") ; return }
  if (!guiaData && !formData) { console.log("Erro: Tentando gerar documento sem dados da guia ou do documento existente em criarDocBodyBDFromGuia") ; return }
  if (!formData) { console.log("Erro: Tentando gerar documento sem passar os dados do documento em criarDocBodyBDFromGuia") ; return }

  const idTipoImovel = guiaData?.detalhesGuia.subTipoDocDestino
  const complexidade = (guiaData ?? docData)?.taxas?.complexidade ?? "-"
  const taxaTotal = (guiaData ?? docData ?? formData).taxas?.taxaTotal + (guiaData?.detalhesGuia?.adiantamentoProtocolo ? Number(guiaData?.detalhesGuia?.adiantamentoProtocolo) : 0.0)
  const taxaDemarc = guiaData?.taxas?.taxaDemarcacao
  const taxaVistoria = guiaData?.taxas?.taxaVistoria

  return {
    ...DadosGerais(tipoDoc, subTipoDoc, formData, guiaData, undefined, undefined),
    ...SecAreasLotes(formData),
    ...SecAreasVerdes(formData),
    ...SecAreasSistViario(formData),
    ...SecCertifico(formData), // tipoDoc, formData, guiaData?.detalhesGuia?.taxInputs?.tipoImovel ?? formData.tipoImovel
    ...montagemSecoes(tipoDoc, subTipoDoc, formData, idTipoImovel),
    ...SecDetalhesMulta(formData, docData?.detalhesMulta?.fatoConstitutivo, docData?.detalhesMulta?.taxInputs),
    ...SecEspecificEmpreendimento(formData),
    ...SecNotas(formData),
    ...SecObs(formData),
    ...SecRepresentante(formData),
    ...SecTaxas(taxaTotal, taxaDemarc, taxaVistoria, complexidade, undefined)
  }
}

function montagemSecoes(tipoDoc, subTipoDoc, formData, idTipoImovel)
{
  return {
    ...SecAutenticacao(tipoDoc, subTipoDoc),
    ...SecDadosCartoriais(formData),
    ...SecConclusao(formData),
    ...SecContratada(formData),
    ...SecContratante(formData),
    ...SecDadosImovel(formData),
    ...SecEnderecoProprietario(formData),
    ...SecDadosObra(formData),
    ...SecDadosObraInfra(formData),
    ...SecDadosServico(formData),
    ...SecDescricaoConfrontantes(formData),
    // ...SecDetalhesGuia(data, obsTexto, taxInputData),
    // ...SecDetalhesMulta(fatoGerador, data, taxInputData),
    ...SecEspecificAutorizacao(formData),
    // ...SecEspecificEmpreendimento(data, taxInputData),
    ...SecFinalidade(formData),
    ...SecMemorialDescritivo(formData),
    // ...SecNotas(nameServ, data),
    ...SecPavimentos(formData),
    ...SecProprietario(formData),
    //...SecObs(tipoDoc, subTipoDoc, data),
    ...SecRegistroProcessosImovel(formData),
    // ...SecRepresentante(data),
    ...SecRequerente(formData),
    ...SecRespTecs(formData),
    ...SecServicosASeremRealizados(formData),
    ...SecUnidHab(formData),
    ...SecUsoOcupSolo(formData, idTipoImovel),
    ...SecVagasEstac(formData),
    // ...SecTaxas(taxaTotal, taxaDemarc, taxaVistoria, complexidade, undefined)
  }
}

function montarFatoGerador()
{
  // const fatoGer = docData?.fatoGerador ?? MontarFatoGerador(docData, idServico, taxInputs.fatoGeradorProtocolo, tipoServico, taxInputs.tipoImovel ?? taxInputs?.subTipoDoc)
  
    // let parcelasTexto = determineParcelasData(idServico, temParcelamento(docData, idServico), formData.parcelasPagamento, taxResults.taxaTotal, taxResults.outorga)
  // if (docData)
  // {
  //     parcelasTexto = parcelasTexto || docData.detalhesGuia.parcelamento
  // }
  // let obsTexto = docData ? "" : determineTaxData(taxResults.detalhesDaAvaliacao, taxResults.detalhesDoCalculo, taxInputs)
  // if (docData)
  // {
  //     let linesObs = docData.detalhesGuia.detalhesTaxa[0].split("\n")
  //     linesObs = linesObs.filter(det => !det.includes("parcela") && !det.includes("parcelada"))
  //     for (let i = 0 ; i <= linesObs.length - 1 ; i += 1)
  //     {
  //         if (i === 0)
  //         {
  //             obsTexto += linesObs[i]
  //             continue
  //         }

  //         obsTexto += "\n" + linesObs[i]
  //     }
  // }
}

function getDataGroupInputs(data, groupName)
{
  const numberGroupItems = countItemsInGroupFields(data, groupName)
  return mapInputGroups(numberGroupItems, groupName, data)
}

function dataFromTaxResults(taxResultsData)
{
  
  if (!taxResultsData) { return {}}
  
  const complex = taxResultsData.detalhesDaAvaliacao?.complexidade?.replace("Categoria de complexidade = ", "")
  let taxaDemarcacao
  let taxaVistoria
  
  if (taxResultsData.taxas)
  {
    taxaDemarcacao = taxResultsData.taxas.filter(taxa => taxa.nome === "Taxa de demarcação")[0]?.valor
    taxaVistoria = taxResultsData.taxas.filter(taxa => taxa.nome === "Taxa de vistoria de demarcação")[0]?.valor
  }

  return {
    taxaTotal: taxResultsData.TaxaTotal ?? taxResultsData.taxaTotal,
    taxaDemarcacao: taxaDemarcacao,
    taxaVistoria: taxaVistoria,
    complexidade: complex,
    outorga: taxResultsData.Outorga ?? taxResultsData.outorga
  }

}

function calcIndicesUrb(areaComputavel, areaPermeavel, areaTerreno)
{
  if (!areaComputavel || !areaPermeavel || !areaTerreno) { return {}}
  
  const coefAprov = (areaComputavel / areaTerreno).toFixed(2).toString()
  const taxaPerm = Math.round(10000 * areaPermeavel / areaTerreno) / 100.0
  return { "coefAprov": coefAprov, "taxaPerm": taxaPerm}
}

// function determineTestemunhas(idServico, input)
// {
//     if (idServico !== "AutoDeInfracao") { return { "testemunhaNomes": [], "testemunhaEnderecos": []} }

//     const numberTestemunhas = CountItemsInGroupFields(input, "testemunha", 2)

//     let testemunhaNomes = []
//     let testemunhaEnderecos = []
//     for (let i = 0; i <= numberTestemunhas - 1; i += 1)
//     {
//         testemunhaNomes.push(input["testemunhaNome" + i])
//         testemunhaEnderecos.push(input["testemunhaEndereco" + i])
//     }

//     return { testemunhaNomes, testemunhaEnderecos }
// }

// export function testemunhasBD(idServico, docInputs)
// {
//     const testemunhas = determineTestemunhas(idServico, docInputs)
//     const todasTestemunhas = []

//     testemunhas.testemunhaNomes.forEach(testemunha => {
//         todasTestemunhas.push({
//             nome: testemunha.testemunhaNomes,
//             endereco: testemunha.testemunhaEnderecos
//         })
//     })

//     return todasTestemunhas
// }

function fatoConstitutivoMulta(idServico, areaConstruida, obraEmExecucao, tipoImovel, docInputs)
{
  // console.log(idServico);
  // console.log(areaConstruida);
  // console.log(obraEmExecucao);
  // console.log(tipoImovel);
  // console.log(docInputs);


  const qtdDocsOrigem = countItemsInGroupFields(docInputs, inputGroupNames.DocsOrigemMulta)
  const docsOrigem = mapInputGroups(qtdDocsOrigem, inputGroupNames.DocsOrigemMulta, docInputs)


  function gerarTextoDocsOrigem(docsOrigem)
  {
    let texto = 1 <= docsOrigem.length ? ", conforme " : ""
    for (let i = 0 ; i <= docsOrigem.length - 1; i += 1)
    {
      const doc = docsOrigem[i]
      texto += doc.docOrigemMulta + " n° " + doc.numDocOrigem + (doc.docOrigemMulta === "Notificação" ? " emitida em " : " emitido em ") + doc.anoDocOrigem
      texto += i <= docsOrigem.length - 3 ? ", " : (i <= docsOrigem.length - 2 ? " e " : "")
    }
    return texto
  }

  
  if (!docInputs.servico) { return "" }
  
  const textoBase = idServico !== "AutoDeInfracao" ?
  "Do valor da taxa, pelo início de obra sem licença, inciso I, artigo 221 do Código Tributário do Município, Lei Nº.1547/89" :
  "Pela não apresentação do Laudo de Vistoria Técnica, no prazo de 60 (sessenta) dias, contados da ciência da Notificação. " +
  "Inciso I do Art. 6º da Lei nº 1.474/89 alteradas pelo Art. 3º da Lei nº 2.765/99."
  const textoRedutorTaxa = ", com redutor de 30% do seu valor, conforme disposto no art. 227 - parágrafo único do plano diretor de desenvolvimento urbano - PDDU"

  // const temNotificacao = !!docInputs.numNotificacao && !!docInputs.dataNotificacao 
  // const temAutoDeInfracao = !!docInputs.numAutoInfracao && !!docInputs.dataAutoInfracao
  // const dadosAutoEmbargo = pegarDadosDocOrigem(docsOrigem, "Auto de embargo")

  // const textoNotificacao = temNotificacao ? "conforme Notificação n° " + docInputs.numNotificacao + " emitido em " + docInputs.dataNotificacao : ""
  // const textoAutoInfracao = temAutoDeInfracao ? "e Auto de Infração n° " + docInputs.numAutoInfracao + " emitido em " + docInputs.dataAutoInfracao : ""
  // const textoAutoEmbargo = dadosAutoEmbargo ? ", conforme Auto de Embargo n° " + dadosAutoEmbargo.numDocOrigem + " emitido em " + dadosAutoEmbargo.anoDocOrigem : ""
  // const textoAutoInfracao2 = temAutoDeInfracao ? "conforme Auto de Infração n° " + docInputs.numAutoInfracao + " emitido em " + docInputs.dataAutoInfracao : ""
  const textoDocsOrigem = gerarTextoDocsOrigem(docsOrigem)

  switch (idServico)
  {
    case "ObraIniciadaSemLicenca":
    {
      let fatoConstitutivo = textoBase + ", e Lei Complementar n° 200 de 27 de dezembro de 2023, artigos 1° e 2°"

      // if (temNotificacao)
      // {
      //   fatoConstitutivo += textoNotificacao + ", " + (temAutoDeInfracao ? textoAutoInfracao + ", " : "")
      // }
      // else
      // {
      //   fatoConstitutivo += dadosAutoEmbargo ? textoAutoEmbargo + ", " : ""
      //   fatoConstitutivo += temAutoDeInfracao ? textoAutoInfracao2 + ", " : ""
      // }
      fatoConstitutivo += textoDocsOrigem
      fatoConstitutivo += obraEmExecucao === "Não" ? textoRedutorTaxa : ""
      fatoConstitutivo += tipoImovel === "ERB" ? ", conforme Lei Municipal Nº 5.547 de 22 de dezembro de 2022" : ""
      fatoConstitutivo += areaConstruida ? ", obra de " + docInputs.servico.toLowerCase() + " com área construída de " + areaConstruida + " m²" : ""     

      return fatoConstitutivo
    }
    case "ReparosGeraisSemLicenca":
    {
      let fatoConstitutivo = textoBase
      fatoConstitutivo += textoDocsOrigem
      fatoConstitutivo += obraEmExecucao === "Não" ? textoRedutorTaxa + "." : ""   

      return fatoConstitutivo
    }
    case "AutoDeEmbargo":
    {
      let fatoConstitutivo = "Por prosseguimento de obra embargada Inciso IV, artigo 221 do Código Tributário do Município, Lei nº. 1547/89" + textoDocsOrigem

      return fatoConstitutivo
    }
    case "AutoDeInfracao": return textoBase
    default: return null
  }

}

function countItemsInGroupFields(inputFields, groupName)
{

    if (inputFields === undefined || groupName === undefined) { console.log("Tentando contar items em um grupo de campos de input que não existe") ; return }

    // groupName tem que ser o mesmo do nome dado ao grupo em FieldsDocumentos.js (na criação dos campos)
    let numberFieldsInGroup = 0
    Object.keys(inputFields).forEach(inp =>
    {
        if (inp.indexOf(groupName) !== -1 & inp.indexOf("0") !== -1) // input field name contains the group name and the number 0
        {
            numberFieldsInGroup++
        }
    })

    if (numberFieldsInGroup === 0) { return 0 }

    let number = 0
    Object.keys(inputFields).forEach(inp =>
    {
        if (inp.indexOf(groupName) !== -1)
        {
            number++
        }
    })

    return number / numberFieldsInGroup
}

function mapInputLists(input, listName)
{
  let lista = []
  const numberItemsInList = countItemsInGroupFields(input, listName)
  
  for (let i = 0; i <= numberItemsInList - 1; i += 1)
  {
    lista.push(input[listName + i])
  }

  return lista
}

function mapInputGroups(numberItemsInGroup, groupName, input)
{

  if (!Object.values(inputGroupNames).includes(groupName)) { return [] }

  let group = []

  for (let i = 0; i <= numberItemsInGroup - 1; i += 1)
  {
    switch (groupName)
    {
      case inputGroupNames.AreaDemarcada: case inputGroupNames.AreaDesmembrada: case inputGroupNames.AreaRemembrada:
      {
        group.push(input["loteNome" + groupName + i] + ": " + input["loteDescricao" + groupName + i])
        if (i !== numberItemsInGroup - 1)
        {
          group.push("")
        }

        break
      }
      case inputGroupNames.AreasLotes:
      case inputGroupNames.AreasVerdes:
      case inputGroupNames.AreasSistViario:
      {
        group.push(
          {
            "nomeArea": input["nome" + groupName + i],
            "area": input["area" + groupName + i],
          })
        
        break
      }
      case inputGroupNames.DadosObraInfra:
      {
        group.push(
        {
            "logradourosObra": input["logradourosObra" + inputGroupNames.DadosObraInfra + i],
            "classViasObra": input["classViasObra" + inputGroupNames.DadosObraInfra + i],
            "caractViasObra": input["caractViasObra" + inputGroupNames.DadosObraInfra + i],
        })
        break
      }
      case inputGroupNames.MarcosRef:
      {
        group.push(
        {
            "nome": input[inputGroupNames.MarcosRef + "Nome" + i],
            "cota": input[inputGroupNames.MarcosRef + "Cota" + i],
        })
        break
      }
      case inputGroupNames.Pavimentos:
      {
          group.push(
          {
              "qtd": input["pavimentosQuantidade" + i].toString(),
              "classificacao": input["pavimentosClassificacao" + i],
              "areaConstruida": input["pavimentosAreaConstruida" + i].toString() + " m²",
              "detAreaConstruida": input["pavimentosDetAreaConstruida" + i],
              "especificacoes": input["pavimentosDescricaoAmbientes" + i]
          })
          break
      }
      case inputGroupNames.UnidHad:
      {
          group.push(
          {
            "tipo": input["tipo" + groupName + i],
            "qtd": emptyStringToUndefined(input["qtd" + groupName + i]),
            "areaUtil": emptyStringToUndefined(input["areaUtil" + groupName + i]),
            "areaConstruida": emptyStringToUndefined(input["areaConstruida" + groupName + i]),
            "areaPrivativa": emptyStringToUndefined(input["areaPrivativa" + groupName + i])
          })
          break
      }
      case inputGroupNames.RegistrosMatriculas:
      {
        group.push(input["numero" + groupName + i] + ": " + input["descricao" + groupName + i])
        
        break
      }
      case inputGroupNames.RespTec:
      {
          group.push(
          {
            "tipo": input["tipoRespTec" + i],
            "nome": input["nomeRespTec" + i],
            "creaCau": input["crea_cauRespTec" + i]
          })
          break
      }
      case inputGroupNames.TaxasOcup:
      {
          const taxaOcupPerc = (i + 1) + "° pav: " + Math.round(10000 * Number(input["pavimentosAreaConstruida" + i]) / input.areaTerreno) / 100.0 + "%"
          group.push(taxaOcupPerc)
          break
      }
      case inputGroupNames.Testemunha:
      {
        group.push(
        {
          "testemunhaNome": input["testemunhaNome" + groupName + i].toString(),
          "testemunhaEndereco": input["testemunhaEndereco" + groupName + i].toString()
        })
        break
      }
      case inputGroupNames.DocsOrigemMulta:
      {
        group.push(
        {
          "docOrigemMulta": input[groupName + i].toString(),
          "numDocOrigem": input["numDocOrigem" + groupName + i].toString(),
          "anoDocOrigem": input["anoDocOrigem" + groupName + i]
        })
        break
      }
      default: break
    }
  }

  return group

}


function DadosGerais(tipoDoc, subTipoDoc, formData, guiaData, fatoGerador, idServicoGeradorGuia)
{
  return {
    "oficial": false,
    "autoNumerar": formData.autoNumerar,
    "numDoc": formData.numDoc ?? 0,
    "anoDoc": Number(new Date().getFullYear()),
    "tipoDoc": tipoDoc,
    "subTipoDoc": subTipoDoc,
    "IdGuiaOrigem": guiaData?.id,
    "fatoGerador": fatoGerador ?? "",
    "adendo": idServicoGeradorGuia ?? ""
  }
}

function SecAreasLotes(data)
{
  const numberAreas = countItemsInGroupFields(data, inputGroupNames.AreasLotes)
  const listAreas = mapInputGroups(numberAreas, inputGroupNames.AreasLotes, data)

  if (!listAreas || listAreas.length === 0) { return {} }

  return {
    "areasLotes": {"areas": listAreas }
  }
}

function SecAreasVerdes(data)
{
  const numberAreas = countItemsInGroupFields(data, inputGroupNames.AreasVerdes)
  const listAreas = mapInputGroups(numberAreas, inputGroupNames.AreasVerdes, data)

  if (!listAreas || listAreas.length === 0) { return {} }

  return {
    "areasVerdes": {"areas": listAreas }
  }
}

function SecAreasSistViario(data)
{
  const numberAreas = countItemsInGroupFields(data, inputGroupNames.AreasSistViario)
  const listAreas = mapInputGroups(numberAreas, inputGroupNames.AreasSistViario, data)

  if (!listAreas || listAreas.length === 0) { return {} }

  return {
    "areasSistViario": {"areas": listAreas }
  }
}

function SecCertifico(data) // tipoDoc, docData, tipoImovel
{
  // if (tipoDoc !== TIPO.CertRegul) { return {}}

  // const message = []

  // const introText = "Existe uma edificação conforme a Legislação Urbanistica em vigor, beneficiada pela lei Complementar 165/2017, situada à "
  // const complementoText = docData.complemento ? ", " + docData.complemento : ""
  // const loteText = docData.numLote ? ", Lote " + docData.numLote : ""
  // const quadraText = docData.numQuadra ? ", Quadra " + docData.numQuadra : ""
  // const enderecoText = docData.logradouro + ", n° " + docData.numPorta + complementoText + loteText + quadraText + ", Bairro " + docData.bairro

  // const numPav = countItemsInGroupFields(docData, "pavimento")
  // const edificacaoText = ", de uso " + tipoImovel + ", " + (Number(numPav) <= 1 ? "térrea" : "de " + numPav + " pavimentos")
  // const areaText = ", com área construída de " + docData.areaConstruida + " m²"
  // const descricaoEdificacaoText = ", constando os seguintes compartimentos: "

  // message.push("")
  // message.push("**CERTIFICO PARA OS DEVIDOS FINS QUE:**")
  // message.push("")
  // message.push(introText + enderecoText + edificacaoText + areaText + descricaoEdificacaoText)
  // for (let i = 0 ; i <= numPav - 1; i += 1)
  // {
  //   const qtdPav = docData["pavimentosQuantidade" + i]
  //   const pavimentoText = qtdPav === "1" ? qtdPav + " pavimento " : qtdPav + " pavimentos "
  //   const classificacaoText = docData["pavimentosClassificacao" + i].toLowerCase() + (2 <= Number(qtdPav) ? "es" : "")
  //   const areaConstText = ", com área construída de " + docData["pavimentosAreaConstruida" + i] + " m²"
  //   const descricaoText = ", contendo: " + docData["pavimentosDescricaoAmbientes" + i]
  //   message.push(pavimentoText + classificacaoText + areaConstText + descricaoText)
  // }
  // message.push("")
  // message.push("Os termos acima deverão ser transcritos na íntegra pelo Cartório de Registros.")
  // message.push("")

  // return { "certifico": message }

  return { "certifico": data.certifico }
}

function SecProprietario(data)
{
  if (!data.nomeProprietario && !data.cpfCnpjProprietario) { return {} }

  return {
    "proprietario":
    {
      "nomeProprietario": data.nomeProprietario,
      "cpfCnpjProprietario": data.cpfCnpjProprietario
    }
  }
}

function SecDadosCartoriais(data)
{

  if (!data.matriculaRegistro && !data.cartorioZonaImob && !data.superintUniaoSE) { return {}}

  return {
    dadosCartoriais:
    {
      matriculaRegistro: data.matriculaRegistro,
      cartorioZonaImob: data.cartorioZonaImob,
      superintUniaoSE: data.superintUniaoSE
    }
  }
}

function SecConclusao(data)
{
  if (data.conclusao === undefined) { return {} }

  const values = data.conclusao ? ["deferida", "pode", " A emissão da presente Certidão não implica no deferimento do licenciamento do empreendimento."] : ["indeferida", "não pode", ""]
  const textoConclusao = "Certidão " + values[0] + " – O imóvel com as características apresentadas " + values[1] + " ser implantado no local solicitado." + values[2]

  return {
    "conclusao":
    {
      "conteudo": textoConclusao
    }
  }
}

function SecContratante(data)
{
  if (!data.contratante && !data.cpfCnpjContratante && !data.enderecoContratante) { return {} }

  return {
    "contratante":
    {
      "contratante": data.contratante,
      "cpfCnpjContratante": data.cpfCnpjContratante,
      "enderecoContratante": data.enderecoContratante
    }
  }
}

function SecDadosImovel(data)
{

  if (!data.inscCadastral && !data.logradouro && !data.numPorta && !data.loteamento
    && !data.numQuadra && !data.numLote && !data.bairro && !data.cep
    && !data.complemento && !data.nomeEmpreendimento && !data.atividade) { return {} }

  return {
    "dadosImovel":
    {
      "inscCadastral": data.inscCadastral,
      "logradouro": data.logradouro,
      "numPorta": data.numPorta,
      "loteamento": data.loteamento,
      "numQuadra": data.numQuadra,
      "numLote": data.numLote,
      "bairro": data.bairro,
      "cep": data.cep,
      "complemento": data.complemento,
      "nomeEmpreendimento": data.nomeEmpreendimento,
      "atividade": data.atividade
    }
  }
}

function SecEnderecoProprietario(data)
{
  if (!data.logradouroProprietario && !data.numPortaProprietario &&
      !data.bairroProprietario && !data.cepProprietario && !data.complementoProprietario) { return {} }

  return {
    "enderecoProprietario":
    {
      "logradouroProprietario": data.logradouroProprietario,
      "numPortaProprietario": data.numPortaProprietario,
      "bairroProprietario": data.bairroProprietario,
      "cepProprietario": data.cepProprietario,
      "complementoProprietario": data.complementoProprietario,
    }
  }
}

function SecContratada(data)
{

  if (!data.contratada && !data.cpfCnpjContratada) { return {} }

  return {
    "contratada":
    {
      "contratada": data.contratada,
      "cpfCnpjContratada": data.cpfCnpjContratada
    }
  }
}

function SecDadosObra(data)
{

  if (!data.logradouroObra && !data.numPortaObra && !data.loteamentoObra && !data.numQuadraObra
      && !data.numLoteObra && !data.bairroObra && !data.cepObra && !data.complementoObra) { return {} }

  return {
    "dadosObra":
    {
      // "nomeEmpreendimento": data.nomeEmpreendimento,
      // "inscricaoCadastral": data.inscricaoCadastral,
      "logradouroObra": data.logradouroObra,
      "numPortaObra": data.numPortaObra,
      "loteamentoObra": data.loteamentoObra,
      "numQuadraObra": data.numQuadraObra,
      "numLoteObra": data.numLoteObra,
      "bairroObra": data.bairroObra,
      "cepObra": data.cepObra,
      "complementoObra": data.complementoObra
    }
  }
}

function SecDadosObraInfra(data)
{  
  const numberDadosObraInfra = countItemsInGroupFields(data, inputGroupNames.DadosObraInfra)
  const listaDadosObraInfra = mapInputGroups(numberDadosObraInfra, inputGroupNames.DadosObraInfra, data)
  const listaBairrosObra = mapInputLists(data, "bairrosObraInfra")
  
  if (!data.bairrosObraInfra && !data.interferenciaSistViario && !data.interferenciaMacrodrenagem
      && (!listaDadosObraInfra || listaDadosObraInfra.length === 0)) { return {} }

  return {
    "dadosObraInfra":
    {
      "bairrosObra": listaBairrosObra,
      "viasObraInfra": listaDadosObraInfra,
      "interferenciaSistViario": data.interferenciaSistViario,
      "interferenciaMacrodrenagem": data.interferenciaMacrodrenagem
    }
  }
}

function SecDadosServico(data)
{

  if (!data.tipoDeObra && !data.valorDosServicos && !data.prazoExecServicos) { return {} }

  return {
    "dadosServico": {
      "tipoDeObra": data.tipoDeObra,
      "valorDosServicos": Number(data.valorDosServicos),
      "prazoExecServicos": data.prazoExecServicos
    },
  }
}

function SecDescricaoConfrontantes(data)
{
  // const registrosMatriculas = getDataGroupInputs(data, inputGroupNames.RegistrosMatriculas)
  const areasDesmembradas = getDataGroupInputs(data, inputGroupNames.AreaDesmembrada)
  const areasRemembradas = getDataGroupInputs(data, inputGroupNames.AreaRemembrada)
  const areasDemarcadas = getDataGroupInputs(data, inputGroupNames.AreaDemarcada)

  if (!data.areaRemanescente && !data.areaDemarcada && !data.situacaoInLoco &&
    // registrosMatriculas <= 0 &&
    areasDesmembradas <= 0 && areasRemembradas <= 0 && areasDemarcadas <= 0) { return {} }

  return {
    "descConfront":
    {
      // "matricula": registrosMatriculas,
      "situacaoInLoco": data.situacaoInLoco,
      "areasDemarcadas": areasDemarcadas,
      "areasDesmembradas": areasDesmembradas,
      "areaRemanescente": data.areaRemanescente, // TODO não está aparecendo no documento
      "areasRemembradas": areasRemembradas,
      "areaTotalDemarcada": data.areaTotalDemarcada
    }
  }
}

function SecDetalhesGuia(idServicoGeradorGuia, data, obsTexto, taxInputData, taxResultsData)
{

  if (!data.parcelasPagamento && !obsTexto) { return {}}

  let tipoDocGerado
  for (let tipoServ of SERVICOS.SERVICOSTAXAS)
  {
    for (let servico of tipoServ.servicos)
    {
      if (servico.id === idServicoGeradorGuia)
      {
        if (idServicoGeradorGuia === "TermoDesm" || idServicoGeradorGuia === "TermoDesmComIncorporacao")
        {
          tipoDocGerado = 40000 <= taxInputData?.areaTerreno ? TIPO.TermoDesmGleba : TIPO.TermoDesmLote
          break
        }
        
        if (idServicoGeradorGuia === "Protocolo")
        {
          tipoDocGerado = "Protocolo"
          break
        }
        
        if (idServicoGeradorGuia === "CertRetEndNum")
        {
          tipoDocGerado = "TEMP"
          break
        }

        tipoDocGerado = servico.docGerado
        break
      }
    }
  }

  const tipoDocDestino = tipoDocGerado


  let formattedTaxInputData = {...taxInputData}
  Object.entries(formattedTaxInputData).forEach(entry => {
    if (entry[1] === "on")
    {
      formattedTaxInputData[entry[0]] = "Sim"
    }
  })
  console.log(taxResultsData);
  

  return {
    "detalhesGuia":
    {
      "tipoDocDestino": tipoDocDestino,
      "subTipoDocDestino": SUBTIPOFROMTIMPOIMOVEL[taxInputData.tipoImovel],
      "qtdParcelas": data.parcelasPagamento ? (data.parcelasPagamento.includes("vezes") ? Number(data.parcelasPagamento[0]) : 1) : 1,
      "taxInputs": formattedTaxInputData,
      "adiantamentoProtocolo": taxResultsData?.adiantamentoProtocolo,
      "detalhesTaxa": [obsTexto]
    }
  }
}

function SecDetalhesMulta(data, fatoConstitutivo, taxInputData)
{

  const numberDocsOrigemMulta = countItemsInGroupFields(data, inputGroupNames.DocsOrigemMulta)
  const docsOrigemMulta = mapInputGroups(numberDocsOrigemMulta, inputGroupNames.DocsOrigemMulta, data)

  if (!data.fatoConstitutivo && docsOrigemMulta.length <= 0 && !data.moraDiaria && !data.vencimento) { return }
  

  let formattedTaxInputData
  if (taxInputData)
  {
    formattedTaxInputData = {...taxInputData}
    Object.entries(formattedTaxInputData).forEach(entry => {
      if (entry[1] === "on")
      {
        formattedTaxInputData[entry[0]] = "Sim"
      }
    })
  }

  return {
    "detalhesMulta":
    {
      "docsOrigemMulta": 1 <= docsOrigemMulta.length ? docsOrigemMulta : undefined,
      "taxInputs": formattedTaxInputData,
      "fatoConstitutivo": fatoConstitutivo,
      "moraDiaria": data.moraDiaria,
      "vencimento": data.vencimento
    }
  }
}

function SecUsoOcupSolo(data, idTipoImovel)
{
  if (!data.macrozoneamento && !data.servico && !idTipoImovel && !data.atividade
    && !data.adeAia && !data.zoneamentoAeroporto && !data.zonaProtecao && !data.zonaRuido) { return {} }
    
    const { coefAprov, taxaPerm } = calcIndicesUrb(data.areaComputavel, data.areaPermeavel, data.areaTerreno)
    
    const numberPav = countItemsInGroupFields(data, "pavimento")

    return {
    "usoOcupSolo":
    {
      "servico": data.servico,
      "classificacaoUso": idTipoImovel ?? data.classificacaoUso,
      "atividade": data.atividade,
      "macrozoneamento": data.macrozoneamento,
      "adeAia": data.adeAia,
      "zoneamentoAeroporto": data.zoneamentoAeroporto,
      "zonaProtecao": data.zonaProtecao,
      "zonaRuido": data.zonaRuido,
      "coefAprov": coefAprov ?? Number(coefAprov),
      "taxaPerm": taxaPerm,
      "taxaOcupPav": mapInputGroups(numberPav, "taxasOcupacao", data), // data.taxaOcupacao
      "usosIncomodos": [data.usosIncomodos ?? ""],
      "imovelConstruido": data.imovelConstruido,
      "equipImpacto": data.equipamentosImpacto,
      "zonaViaria": data.classificacaoViaria,
      "areaSubJudice": data.areaSubJudice,
      "areaNonAedifSV": data.areaNonEdificantiSistViario,
      "areaNonAedifIP": data.areaNonEdificantiIntPublico,
      "paisagemNotavel": data.paisagemNotavel,
      "patrimonioCultural": data.patrimonioCultural
    }
  }
}

function SecEspecificAutorizacao(data)
{
  const numberRegistros = countItemsInGroupFields(data, "registrosMatriculas")
  const listaRegistros = mapInputGroups(numberRegistros, "registrosMatriculas", data)

  if (!data.tipoServico && !data.areaTotal && !data.registroMatricula && (!listaRegistros || listaRegistros.length === 0)) { return {} }
  // if (listaRegistros.length === 0) { return {} }

  // const listaRegistros = data.registroMatricula !== undefined ? data.registroMatricula.map(registroMatricula => salvarRegistrosMatriculas(registroMatricula)) : undefined

  return {
    "especificAutorizacao":
    {
      "tipoServico": data.tipoServico,
      "areaTotal": data.areaTotal,
      "registros": listaRegistros.length === 0 ? undefined : listaRegistros,
      // "matriculas": data.matriculas,
      // "servicos": data.servicos
    }
  }
}

function emptyStringToUndefined(value) { return value === "" ? undefined : value }

function SecEspecificEmpreendimento(data, taxInputData)
{

  if (!data.areaTerreno && !data.areaAverbada && !data.areaRegularizar && !data.areaReforma
    && !data.areaDemolir && !data.areaAcrescida && !data.areaConstruida && !data.areaComputavel
    && !data.areaPermeavel && !data.blocosUnidades && !data.unidades && !data.numPav
    && !data.gabaritoAltura && !data.numElevadores && !data.numeroPlataformas
    && !data.centroHistorico && !data.interesseCultural
    && !data.entornoPatrimonioCultural && !data.obraPublica) { return {} }

  return {
    "especificEmpreendimento":
    {
      "areaTerreno": emptyStringToUndefined(data.areaTerreno),
      "areaAverbada": emptyStringToUndefined(data.areaAverbada),
      "areaRegularizar": emptyStringToUndefined(data.areaRegularizar),
      "areaReforma": emptyStringToUndefined(data.areaReforma),
      "areaDemolir": emptyStringToUndefined(data.areaDemolir),
      "areaAcrescida": emptyStringToUndefined(data.areaAcrescida),
      "areaConstruida": emptyStringToUndefined(data.areaConstruida),
      "areaComputavel": emptyStringToUndefined(data.areaComputavel),
      "areaPermeavel": emptyStringToUndefined(data.areaPermeavel),
      "blocos": data.blocosUnidades || data.blocos,
      "unidades": data.unidades,
      "numPav": emptyStringToUndefined(data.numPav),
      "gabaritoAltura": emptyStringToUndefined(data.gabaritoAltura),
      "numElevadoresPlataformas": (data.numElevadores ?? "") + " | " + (data.numeroPlataformas ?? ""),
      "areaLagoa": emptyStringToUndefined(data.areaLagoa),
      "areaVia": emptyStringToUndefined(data.areaVia),
      "areaLiquida": emptyStringToUndefined(data.areaLiquida),
      "qtdLotes": data.qtdLotes,
      "areaVerde": emptyStringToUndefined(data.areaVerde),
      "sistViario": emptyStringToUndefined(data.sistViario),
      "areaLotes": emptyStringToUndefined(data.areaLotes),
      "centroHistorico": data.centroHistorico,
      "interesseCultural": data.interesseCultural,
      "entornoPatriCult": data.entornoPatrimonio,
      "obraPublica": data.obraPublica,
      "elevadores": data.numElevadores,
      "infraLocal": data.infraestruturaLocal,
      "vizinhanca500m": data.vizinhanca
    }
  }
}

function SecFinalidade(data)
{
  if (!data.finalidade) { return {} }

  return {
    "finalidade":
    {
      "finalidade": data.finalidade
    }
  }
}

function SecMemorialDescritivo(data)
{
  if (!data.memorialDescritivo) { return {} }

  return {
    "memorialDescritivo":
    {
      "descricao": data.memorialDescritivo
    }
  }
}

function SecNotas(data)
{
  if (!data.notas) { return {}}

  return {
    "notas":
    {
      "notas": [data.notas]
    }
  }
}

function SecObs(data)
{
  const listaObs = mapInputLists(data, "obs").map(obs => [obs])
  
  return { "obs": {"observacoes": listaObs} }
}
 
function SecPavimentos(data)
{
  if (!data.pavimentosAreaConstruida0) { return {}}

  const numberPav = countItemsInGroupFields(data, "pavimento")
  const listaPavimentos = mapInputGroups(numberPav, "pavimentos", data)

  if (!listaPavimentos || listaPavimentos.length === 0) { return {} }

  return {
    "pavimentos": {"pavimentos": listaPavimentos }
  }
}

function SecRegistroProcessosImovel(data)
{
 // TODO DeclAtendTermoCompr usa a parte comentada
  // if (!data.documentoOrigem || !data.processoOrigem) { return {} }
  if (!data.registroAutRepGerais || !data.registroProcesso) { return {} }

  return {
    registroProcessosImovel:
    {
      // registroProcessosImovel: "Autorização para obras de infraestrutura n° " + data.documentoOrigem + ", obtida no processo n°" + data.processoOrigem
      registroProcessosImovel: "Autorização para Instalação de Estação de Rádio-Base n° " + data.registroAutRepGerais + ", obtida no Processo n° " + data.registroProcesso
    }
  }
}

function SecRepresentante(data)
{

  if (!data.nomeProprietario && !data.cpfCnpjProprietario) { return {} }

  return {
    "representante":
    {
      "adminImovel": data.nomeProprietario,
      "cpfCnpj": data.cpfCnpjProprietario
    }
  }
}

function SecRequerente(data)
{

  if (!data.nomeRequerente && !data.cpfCnpjRequerente) { return {} }

  return {
    "requerente":
    {
      "nomeRequerente": data.nomeRequerente,
      "cpfCnpjRequerente": data.cpfCnpjRequerente
    }
  }
}

function SecRespTecs(data)
{
  // const listaRespTecs = data.respTec !== undefined ? data.respTec.map(respTec => salvarRespTec(respTec)) : undefined

  const numberRespTec = countItemsInGroupFields(data, "RespTec")
  const listaRespTecs = mapInputGroups(numberRespTec, "respTec", data)

  if (!listaRespTecs || listaRespTecs.length === 0) { return {} }

  return {
    "respTecs": {"respTecs": listaRespTecs }
  }
}

function SecServicosASeremRealizados(data)
{
  const listaServicos = mapInputLists(data, "servicosASeremRealizados")

  if (!listaServicos || listaServicos.length === 0) { return {} }

  return {"servicosASeremRealizados": {"servico": listaServicos}}
}

function SecUnidHab(data)
{
  const numberUnidHab = countItemsInGroupFields(data, "unidadesHabitacionais")
  const listaUnidHab = mapInputGroups(numberUnidHab, "unidadesHabitacionais", data)

  if (!listaUnidHab || listaUnidHab.length === 0) { return {} }

  return {
    "unidHabit":
    {
      "unidsHabitacionais": listaUnidHab
    }
  }
}

function SecVagasEstac(data)
{
  if (!data.vagasVeiculo && !data.vagasMoto && !data.vagasBicicleta && !data.descricaoVagas) { return {} }

  return {
    "vagasEstac":
    {
      "vagasVeiculo": data.vagasVeiculo,
      "vagasMoto": data.vagasMoto,
      "vagasBicicleta": data.vagasBicicleta,
      "descricaoVagas": data.descricaoVagas
    }
  }
}

function SecTaxas(taxaTotal, taxaDemarcacao, taxaVistoria, complexidade, outorga)
{
  return {
    "taxas": {
      "complexidade": complexidade,
      "outorga": outorga,
      "taxaTotal": taxaTotal,
      "taxaDemarcacao": taxaDemarcacao, // 0 < taxaDemarcacao?.length ? taxaDemarcacao[0]?.valor : undefined,
      "taxaVistoria": taxaVistoria // 0 < taxaVistoria?.length ? taxaVistoria[0]?.valor : undefined
    }
  }
}

function SecAutenticacao(tipoDoc, subTipoDoc)
{
  const analista = {
    "matricula": userData().matricula,
    "nome": userData().nome,
    "tipo": userData().funcao,
    "funcao": "Analista"
  }
  const coordUrb = {
    "matricula": "005873",
    "nome": "Arq. Catharina Nunes Cruz",
    "tipo": "Arquiteto",
    "funcao": "Coordenador"
  }
  const dirUrb = {
    "matricula": "001250",
    "nome": "Ederson Zucolotto",
    "tipo": "Arquiteto",
    "funcao": "Diretor"
  }
  const presidencia = 
  {
    "matricula": "",
    "nome": "Antônio Sérgio Ferrari Vargas",
    "tipo": "Engenheiro",
    "funcao": "Presidente"
  }

  const funcionarios = [ analista, coordUrb, dirUrb ]

  if (docPassaPelaPresidencia(tipoDoc, subTipoDoc))
  {
    funcionarios.push(presidencia)
  }

  return {
    "autenticacao":
    {
      "funcionarios": funcionarios
    }
  }
}

function docPassaPelaPresidencia(tipoDoc, subTipoDoc)
{
  if (tipoDoc === TIPO.Alvara)
  {
      return subTipoDoc === SUBTIPO.MultiresidencialAte4Pav || subTipoDoc === SUBTIPO.MultiresidencialAcima4Pav || subTipoDoc === SUBTIPO.NaoResidencial || subTipoDoc === SUBTIPO.Loteamento ;
  }
  if (tipoDoc === TIPO.Anuencia)
  {
      return subTipoDoc === SUBTIPO.Loteamento ;
  }
  
  return tipoDoc === TIPO.AutObrasInfra || tipoDoc === TIPO.CertRegul || tipoDoc === TIPO.CertRegulInfra || tipoDoc === TIPO.Habitese ;

}

function MapNameServToTipoDoc(nameServ)
{
  if (nameServ.startsWith("Alvara")) { return "Alvara"}
  if (nameServ.startsWith("Anuencia")) { return "Anuencia"}

  return nameServ
}
